import React from 'react'
import { RecommendGenreCardImage } from './CardImage'
import { RecommendGenreCardText } from './CardText'
import Link from 'next/link'

type Props = {
  image: {
    src: string
    alt: string
    width: number
    height: number
  }
  text: string
}

export const RecommendGenreCard = ({ image, text }: Props): JSX.Element => {
  return (
    <Link href={`/programs/${text}`}>
      <a>
        <div className="flex flex-col justify-center items-center mb-[5.3vw] lg:mb-0 w-[40.5vw] lg:w-[14.1vw] h-[40.5vw] lg:h-[14.1vw] bg-white rounded-[20px] shadow-toppage lg:hover:opacity-50">
          <div className="mb-[3.6vw] lg:mb-[1.25vw]">
            <RecommendGenreCardImage {...image} />
          </div>
          <RecommendGenreCardText {...{ text }} />
        </div>
      </a>
    </Link>
  )
}
